var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{
    'sd-icon--click': _vm.hasClick,
  },style:(_vm.dimensions),attrs:{"src":require(("@/assets/img/" + _vm.src + "." + _vm.extension))},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }